import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { loginUser } from "../../redux/features/auth/authThunks";

// Validation Schema using Yup
const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required")
    .matches(
      /^[a-zA-Z0-9._%+-]+@orderseazen\.com$/,
      "Email must be a valid OrderSeazen email"
    ),
  password: Yup.string().required("Password is required"),
});

export const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (values) => {
    try {
      const response = await dispatch(loginUser(values)); // Dispatch the loginUser action
      if (response?.token) {
        // Redirect to another page upon successful login (e.g., dashboard or home)
        navigate("/main-page");
      }
    } catch (error) {
      console.error("Login failed:", error);
      // Handle login failure (e.g., show error message)
    }
  };

  return (
    <>
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-full max-w-sm p-6 rounded-lg">
          {/* Logo Section */}
          <div className="flex justify-center mb-8">
            <img
              src="/Images/Logo.png"
              alt="OrderSeazen Logo"
              className="h-auto w-auto"
            />
          </div>

          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={validationSchema}
            onSubmit={handleLogin}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="mb-4">
                  <Field
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email"
                    className="w-full px-4 py-2 border border-slate-300 bg-neutral-50 h-12 rounded-xl focus:ring-1 focus:ring-slate-300 focus:outline-none placeholder-gray-400 placeholder-bold"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <div className="mb-4">
                  <Field
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Password"
                    className="w-full px-4 py-2 border border-slate-300 bg-neutral-50 rounded-xl h-12 focus:ring-1 focus:ring-slate-300 focus:outline-none placeholder-gray-400 placeholder-bold"
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full px-4 py-2 text-white bg-amber-800 rounded-xl h-12 focus:ring-1 focus:ring-amber-800 focus:outline-none placeholder-white placeholder-bold"
                >
                  {isSubmitting ? "Logging in..." : "Login"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};
